module.exports = __webpack_public_path__ + "img/image-2.2eefc639.jpg";